const Button = (props) => (
    <button 
    onClick={props.click}
    className={"transition duration-400 hover:bg-black hover:text-white text-black border-2 border-black rounded-full px-8 py-4 " + props.className}>
        {props.label}
    </button>
)

export default Button